import "./ProgressBar.css";

const ProgressBar = ({ width = 0, current = 1, total = 3 }) => {
  // width가 0-100 사이의 퍼센트 값이라고 가정
  const percentage = Math.min(Math.max(width, 0), 100);

  return (
    <div className="progress-bar-container">
      <div className="progress-bar-wrapper">
        <div className="progress-bar-background">
          <div
            className="progress-bar-fill"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
      <div className="progress-bar-text">
        {current}/{total}
      </div>
    </div>
  );
};

export default ProgressBar;
